import React, { useState } from "react";
import { authFetch } from "../../utils/api"; // ✅ import helper

export default function FbAdsScraper() {
  const [keyword, setKeyword] = useState("");
  const [country, setCountry] = useState("US");
  const [category, setCategory] = useState("ALL");
  const [limit, setLimit] = useState(20);
  const [status, setStatus] = useState("");

  const adCategories = [
    { value: "ALL", label: "All Ads" },
    { value: "HOUSING", label: "Housing" },
    { value: "CREDIT", label: "Credit" },
    { value: "EMPLOYMENT", label: "Employment" },
    { value: "POLITICAL", label: "Politics / Issues" },
    { value: "SOCIAL", label: "Social Causes" },
    { value: "PRODUCT", label: "Products / Services" },
  ];

  const countries = [
    { code: "US", name: "United States" },
    { code: "IN", name: "India" },
    { code: "GB", name: "United Kingdom" },
    { code: "CA", name: "Canada" },
    { code: "AU", name: "Australia" },
    { code: "DE", name: "Germany" },
    { code: "FR", name: "France" },
    { code: "BR", name: "Brazil" },
    { code: "MX", name: "Mexico" },
    { code: "JP", name: "Japan" },
    { code: "SG", name: "Singapore" },
  ];

  const handleScrape = async () => {
    setStatus("Scraping started...");
    try {
      const data = await authFetch("/scrape-facebook-ads", {
        method: "POST",
        body: JSON.stringify({ keyword, country, category, limit }),
      });

      setStatus(`Scraping completed ✅ Found ${data.found} Instagram links`);
    } catch (err) {
      console.error(err);
      setStatus(err.message || "❌ Error during scraping");
    }
  };

  return (
    <div className="stage-container">
      <h2 className="form-title">Stage 4: Facebook Ads Library Scraper</h2>

      <div className="form-grid">
        <div className="form-group">
          <label>Keyword / Business Name</label>
          <input
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Country</label>
          <select value={country} onChange={(e) => setCountry(e.target.value)}>
            {countries.map((c) => (
              <option key={c.code} value={c.code}>
                {c.name}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Ad Category</label>
          <select value={category} onChange={(e) => setCategory(e.target.value)}>
            {adCategories.map((cat) => (
              <option key={cat.value} value={cat.value}>
                {cat.label}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Number of Ads to Scrape</label>
          <input
            type="number"
            value={limit}
            onChange={(e) => setLimit(e.target.value)}
          />
        </div>
      </div>

      <button className="submit-btn" onClick={handleScrape}>
        Start Scraping
      </button>

      <p className="form-status">{status}</p>
    </div>
  );
}
